import { allPermissionMapping } from 'shared/constants/permissionConstant';
import AuthService from 'shared/services/auth.service';

export interface AllPermissionRequired {
	permission: string[];
}

export interface AnyOnePermissionRequired {
	anyOnePermission: string[];
}

/**
 * check if user has permission to access any block
 * @param permission : a list of permissions, if user is not having any one permission of the given permissions, return false
 * @param anyOnePermission : a list of optional permissions, if user is having atleast one permission of the given permissions, return true
 */
const checkPermission = (data: AllPermissionRequired | AnyOnePermissionRequired): boolean => {
	const userData = AuthService.getAuthData();
	if (!userData || !userData.permissions) {
		return false;
	}
	if (userData.allPermissions) {
		return true;
	}
	const anyOnePermissionData = data as AnyOnePermissionRequired;
	if (anyOnePermissionData.anyOnePermission) {
		// if user is having atleast one permission of the given permissions, return true
		for (let i = 0; i < anyOnePermissionData.anyOnePermission.length; i += 1) {
			if (userData.permissions[allPermissionMapping[anyOnePermissionData.anyOnePermission[i]]]) {
				return true;
			}
		}
		return false;
	}
	const allPermissionData = data as AllPermissionRequired;

	// if user is not having any one permission of the given permissions, return false
	for (let i = 0; i < allPermissionData.permission.length; i += 1) {
		if (!userData.permissions[allPermissionMapping[allPermissionData.permission[i]]]) {
			return false;
		}
	}
	return true;
};

/**
 * Log all permissions the current user has to the console
 */
const logUserPermissions = (): void => {
	const userData = AuthService.getAuthData();
	if (!userData) {
		console.log('[User Permissions] No user logged in');
		return;
	}
	if (!userData.permissions) {
		console.log('[User Permissions] User has no permissions object');
		return;
	}
	if (userData.allPermissions) {
		console.log('[User Permissions] User has full access (allPermissions: true)');
		return;
	}
	const granted: string[] = [];
	const denied: string[] = [];
	const permissions = userData.permissions;
	Object.keys(allPermissionMapping).forEach((key) => {
		const permissionKey = allPermissionMapping[key];
		if (permissions[permissionKey]) {
			granted.push(`${key} (${permissionKey})`);
		} else {
			denied.push(`${key} (${permissionKey})`);
		}
	});
	console.log('[User Permissions] Granted:', granted);
	console.log('[User Permissions] Denied:', denied);
	console.log('[User Permissions] Summary:', { granted: granted.length, denied: denied.length });
};

export { checkPermission, logUserPermissions };
